import {getAudit as getAuditAPI} from '../../services/audits'

export async function getSingleAudit(id) {
  try {
    let response = await getAuditAPI(id)
    return response
  } catch (e) {
    console.log(`Get Audit Failed: ${id}`)
  }
}
